import React from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import Cross from 'assets/icons/cross.svg'
import ArrowRight from 'assets/icons/arrowRight.svg'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { useLocalStorage } from 'hooks/useLocalStorage'
import { breakpointUpTo } from 'utils/breakpoints'

type WrapperProps = {
  isClosed: boolean
}
const Wrapper = styled.div<WrapperProps>`
  z-index: 2;
  position: fixed;
  display: flex;
  bottom: 0;
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.space[3]};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px -1px 0px #e4e8eb;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    padding: 14px;
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.xs)} {
    justify-content: flex-start;
    a svg {
      display: none;
    }
  }
`
const CloseButton = styled.button`
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  position: absolute;
  right: 21px;
  top: 52%;
  transform: translateY(-50%);
  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    right: 10px;
  }
`
export type CovidBarProps = {
  text: string
  infoLink: string
}
export const CovidBar = ({ text, infoLink }: CovidBarProps) => {
  const [isClosed, setClose] = useLocalStorage<boolean>(
    'is_covid_banner-closed',
    false
  )
  if (isClosed) {
    return null
  }

  return (
    <Wrapper isClosed={isClosed}>
      <ExternalLink href={infoLink}>
        {text.replace('-', '-\u2060')}
        <SVG src={ArrowRight} />
      </ExternalLink>
      <CloseButton onClick={() => setClose(true)} aria-label={'Close bar'}>
        <SVG src={Cross} />
      </CloseButton>
    </Wrapper>
  )
}
